import $ from "jquery";
import videojs from "!video.js";
class Video {
    constructor() {
        var options = {
            controls: false,
            defaultMuted: true,
            autoplay: 'muted',
            loop: true,
            fluid: true
        };
        if((ootlahData.page=="home" || ootlahData.page=="activities" || ootlahData.page=="things-to-do") && ootlahData.video_set==1){
            var player = videojs('ootlah-player', options, function onPlayerReady() {
                videojs.log('Your player is ready2!');
                //videojs.log.level('debug');
                setTimeout(function(){
                    $('.vjs-big-play-button').trigger('click');
                },2000);
                

                // In this context, `this` is the player that was created by Video.js.
                //this.play();

                // How about an event listener?
                this.on('ended', function() {
                    //videojs.log('Awww...over so soon?!');
                });
            });
        }
    }
}

export default Video